import React, { useCallback, useEffect } from 'react'
import { observer, useLocalObservable } from "mobx-react-lite"
import Divider from '@mui/material/Divider';
import OutlinedInput from '@mui/material/OutlinedInput';
// import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Link from '@mui/material/Link';
import LoadingButton from '@mui/lab/LoadingButton';
// import Button from '@mui/material/Button';
import { useNavigate, useLocation } from "@reach/router"

import GoogleButton from './GoogleButton'
import FacebookButton from './FacebookButton';

import classes from './Login.module.scss'
import {ReactComponent as Logo} from '../../logo3.svg'
import Password from '../account/Password'
import userStore from '../common/userStore';
import useTitle from '../../hooks/title';

const inputClasses = {'root':classes.input, 'notchedOutline': classes.notchedOutline}


const Login = observer(() => {
  const navigate = useNavigate()
  const location = useLocation()
  useTitle('Login')
  const form = useLocalObservable(() => ({
    username: '',
    password: '',
    errors: {username: null, password: null, submit: null},
    immediately: false,
    handleUsername(e) {
      this.username = e.target.value
      this.immediately && this.validUsername()
    },
    handlePassword(e) {
      this.password = e.target.value
      this.immediately && this.validPassword()
    },
    validUsername() {
      const rs = this.username.length > 0
      this.errors.username = rs ? null : 'Email or Username is required'
      return rs
    },
    validPassword() {
      const rs = this.password.length > 0 // to 8
      this.errors.password = rs ? null : 'Password is required'
      return rs
    },
    setErrorsSubmit(info) {
      this.errors.submit = info
    },
    async handleSubmit() {
      if (userStore.posting) {
        return;
      }
      const rs = [this.validUsername(), this.validPassword()]
      this.immediately = true
      if (rs[0] && rs[1]) {
        try {
          await userStore.login({
            username: this.username,
            password: this.password,
            rememberMe: 1, // 强制记住
          })
          this.setErrorsSubmit(null)
        } catch(e) {
          console.error('login fail', e)
          this.setErrorsSubmit('Oops! Your email and password don\'t match')
        }
        return;
      }
    },
    handleKeyup(e) {
      if(e.keyCode === 13) {
        this.handleSubmit()
      }
    }
  }))

  const toSignup = useCallback(() => {
    const search = location.search;
    navigate('/auth/signup' + search, {replace: true})
  }, [navigate, location])

  const toForgot = useCallback(() => {
    navigate('/auth/forgot-password')
  }, [navigate])

  useEffect(() => {
    if (userStore.needMerge) {
      navigate('/auth/whoops')
      return;
    }
    if (userStore.isLogin) {
      navigate('/')
    }
  }, [navigate, userStore.isLogin, userStore.needMerge])

  return <div className={classes.center}>
      <div className={classes.logo}><Logo onClick={() => navigate('/')} /></div>
      <h1 className={classes.welcome}>Welcome back!</h1>

      <FormControl className={classes.field}>
        <OutlinedInput
          classes={inputClasses}
          name="username"
          size="small"
          placeholder="Email or Username"
          onChange={form.handleUsername}
          onKeyUp={form.handleKeyup} />
      </FormControl>
      <div className={classes.inline}>
        <div className={classes.error}>
          {form.errors.username && form.errors.username}
        </div>
        <div className={classes.forgot}>
          <Link underline="hover" onClick={toForgot}>Forgot password?</Link>
        </div>
      </div>
      <FormControl className={classes.field}>
        <Password classes={inputClasses}
          name="password"
          size="small"
          placeholder="Password"
          onChange={form.handlePassword}
          onKeyUp={form.handleKeyup} />
      </FormControl>
      <div className={classes.error}>
        {form.errors.password ? form.errors.password : (form.errors.submit ? form.errors.submit : null)}
      </div>

      <LoadingButton
        className={classes.submit}
        variant="contained"
        disableElevation
        onClick={form.handleSubmit}
        loading={userStore.posting}
        // disabled={userStore.posting}
        >Log in</LoadingButton>

      <div className={classes.signup}>
        Don’t have an account?
        <Link underline="hover" onClick={toSignup}>Sign up here</Link>
      </div>

      <Divider className={classes.divider} light={true}>or continue with</Divider>

      <div className={classes.actions}>
        <GoogleButton className={classes.google} />
        {/* <FacebookButton className={classes.facebook} /> */}
      </div>
    </div>
})

export default Login
